import React, { Component } from "react";

const WEEKDAYS = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
const MONTHS = [
  "January",
  "February",
  "March",
  "April",
  "May",
  "June",
  "July",
  "August",
  "September",
  "October",
  "November",
  "December",
];

const pad = (value) => String(value).padStart(2, "0");

// Full month grid. Every day cell can add a holiday, and every holiday chip can
// be edited or removed, so the page needs no separate table to manage them.
class HolidayCalendar extends Component {
  state = {
    hover: "",
  };

  // Holidays keep the date the API returns it, which may carry a time part.
  // Only the day matters here.
  DateKey = (value) => String(value || "").slice(0, 10);

  // The visible grid: the days of the month plus the leading and trailing days
  // of the neighbouring months so every week row is complete.
  BuildCells = () => {
    const { year, month } = this.props;
    const days_in_month = new Date(year, month, 0).getDate();
    const first_weekday = new Date(year, month - 1, 1).getDay();
    const days_in_previous = new Date(year, month - 1, 0).getDate();

    const cells = [];
    for (let i = first_weekday; i > 0; i--) {
      cells.push({ day: days_in_previous - i + 1, current: false });
    }
    for (let day = 1; day <= days_in_month; day++) {
      cells.push({
        day,
        current: true,
        date: `${year}-${pad(month)}-${pad(day)}`,
      });
    }
    let next_day = 1;
    while (cells.length % 7 !== 0) {
      cells.push({ day: next_day++, current: false });
    }
    return cells;
  };

  render() {
    const { list, year, month, onAdd, onEdit, onDelete, onMonthChange } = this.props;
    const { hover } = this.state;

    const holidays = {};
    (list || []).forEach((item) => {
      const key = this.DateKey(item.date);
      if (!holidays[key]) holidays[key] = [];
      holidays[key].push(item);
    });

    const today = new Date();
    const today_key = `${today.getFullYear()}-${pad(today.getMonth() + 1)}-${pad(today.getDate())}`;
    const cells = this.BuildCells();
    const total = (list || []).length;

    return (
      <div className="hc">
        {/* Month bar */}
        <div className="hc-bar">
          <div>
            <div className="hc-bar-title">
              {MONTHS[month - 1]} <span className="hc-bar-year">{year}</span>
            </div>
            <div className="hc-bar-sub">
              {total} holiday{total === 1 ? "" : "s"} this month
            </div>
          </div>
          <div className="d-flex align-items-center">
            <div
              className="icon pointer hc-nav"
              title="Previous month"
              onClick={() => onMonthChange?.(-1)}
            >
              {""}
            </div>
            <button
              type="button"
              className="hc-today"
              onClick={() => onMonthChange?.(0)}
            >
              Today
            </button>
            <div
              className="icon pointer hc-nav"
              title="Next month"
              onClick={() => onMonthChange?.(1)}
            >
              {""}
            </div>
          </div>
        </div>

        {/* Weekday header */}
        <div className="hc-weekdays">
          {WEEKDAYS.map((weekday, index) => (
            <div
              key={weekday}
              className={`hc-weekday ${index === 0 || index === 6 ? "weekend" : ""}`}
            >
              {weekday}
            </div>
          ))}
        </div>

        {/* Days */}
        <div className="hc-grid">
          {cells.map((cell, index) => {
            const items = cell.current ? holidays[cell.date] || [] : [];
            const is_today = cell.current && cell.date === today_key;
            const is_weekend = index % 7 === 0 || index % 7 === 6;
            const hovered = hover === index;
            // The whole day is the add target so adding works without a hover,
            // the plus icon is only the affordance for it.
            return (
              <div
                key={`cell-${index}`}
                className={[
                  "hc-cell",
                  cell.current ? "current pointer" : "other",
                  items.length ? "holiday" : "",
                  is_weekend ? "weekend" : "",
                  is_today ? "today" : "",
                  (index + 1) % 7 === 0 ? "last" : "",
                ].join(" ")}
                onClick={() => cell.current && onAdd?.(cell.date)}
                onMouseEnter={() => this.setState({ hover: index })}
                onMouseLeave={() => this.setState({ hover: "" })}
              >
                <div className="hc-cell-head">
                  <div className="hc-day">{cell.day}</div>
                  {cell.current && hovered && (
                    <div
                      className="icon pointer hc-add"
                      title="Add holiday"
                      onClick={() => onAdd?.(cell.date)}
                    >
                      {""}
                    </div>
                  )}
                </div>
                <div className="hc-cell-body">
                  {items.map((item) => (
                    <div key={item.uid} className="hc-chip" title={item.name}>
                      <span
                        className="hc-chip-name pointer text-truncate"
                        title="Update"
                        onClick={(e) => {
                          e.stopPropagation();
                          onEdit?.(item);
                        }}
                      >
                        {item.name || "-"}
                      </span>
                      <span
                        className={`icon pointer hc-chip-del ${hovered ? "show" : ""}`}
                        title="Delete"
                        onClick={(e) => {
                          e.stopPropagation();
                          onDelete?.(item);
                        }}
                      >
                        {""}
                      </span>
                    </div>
                  ))}
                </div>
              </div>
            );
          })}
        </div>
      </div>
    );
  }
}

export default HolidayCalendar;
